import * as R from 'ramda';
import { createSelector } from 'reselect';

import i18n from 'containers/App/i18n';

const placeholderUntilLoaded = {
  promotionsText: '',
  tableProductColText: '',
  tableCodeColText: '',
  tableQuantityColText: '',
  tableDiscountColText: '',
  tablePriceColText: '',
  summaryDiscountText: '',
  summaryTaxText: '',
  summaryNetText: '',
  summaryTotalText: '',
  donationTitle: '',
  donationSubtitle: '',
  donationInputPlaceholder: '',
  donationButtonOkText: '',
  donationConfirmationTitle: '',
  donationAmountReplacementIdentifier: '',
  donationConfimationSubtitle: '',
  donationButtonConfirmText: '',
  donationButtonCancelText: '',
  donationThankingText: '',
  tipTitle: '',
  tipSubtitle: '',
  tipInputPlaceholder: '',
  tipButtonOkText: '',
  tipConfirmationTitle: '',
  tipAmountReplacementIdentifier: '',
  tipConfimationSubtitle: '',
  tipButtonConfirmText: '',
  tipButtonCancelText: '',
  tipThankingText: '',
  emailLookupTitle: '',
  emailLookupSubtitle: '',
  emailLookupInputPlaceholder: '',
  emailLookupButtonOkText: '',
  phoneLookupTitle: '',
  phoneLookupSubtitle: '',
  phoneLookupInputPlaceholder: '',
  phoneLookupButtonOkText: '',
  registerCustomerTitle: '',
  registerCustomerConfirmationTitle: '',
  registerCustomerConfirmationSubtitle: '',
  registerCustomerButtonConfirmText: '',
  registerCustomerButtonCancelText: '',
  registerCustomerSuccessfulText: '',
  registerCustomerFailedText: '',
  couponTitle: '',
  couponSubtitle: '',
  couponInputPlaceholder: '',
  couponConfirmationTitle: '',
  couponButtonOkText: '',
  couponCodeReplacementIdentifier: '',
  couponConfirmationSubtitle: '',
  couponButtonConfirmText: '',
  couponButtonCancelText: '',
  couponCodeAppliedTitle: '',
  couponCodeDiscountIdentifier: '',
  couponCodeAppliedSubtitle: '',
  couponCodeFailedTitle: '',
  couponCodeFailedSubtitle: '',
  upsellTitle: '',
  upsellPriceText: '',
  upsellAddText: '',
  upsellConfirmationTitle: '',
  upsellConfirmationSubtitle: '',
  upsellConfirmationButtonConfirmText: '',
  upsellConfirmationButtonCancelText: '',
  upsellPurchaseSuccessTitle: '',
  upsellPurchaseSuccessSubtitle: '',
  upsellPurchaseFailedTitle: '',
  thankYouForShoppingText: '',
  qrCodeDataText: '',
  qrTitle: '',
  qrSubtitle: '',
  rateServiceTitle: '',
  rateServiceSubtitle: '',
  rateServiceCompletedTitle: '',
  rateServiceCompletedSubtitle: '',
  rateServiceInputPlaceholder: '',
  customerCheckInTitle: '',
  customerCheckInSubtitle: '',
  customerCheckInAddCustomer: '',
  customerCheckInLookUpCustomer: '',
  customerCheckInCoupon: '',
  registerCustomerForm: {
    label: {
      firstName: '',
      lastName: '',
      email: '',
      zip: '',
      code: '',
      customerCardNumber: '',
      phone: '',
      mobile: '',
      emailOptOut: '',
      privacy: '',
      termsAndConditions: '',
      birthday: '',
    },
    placeholder: {
      firstName: '',
      lastName: '',
      email: '',
      zip: '',
      code: '',
      customerCardNumber: '',
      phone: '',
      mobile: '',
      emailOptOut: '',
      birthday: '',
    },
    requiredMessage: {
      firstName: '',
      lastName: '',
      email: '',
      zip: '',
      code: '',
      customerCardNumber: '',
      phone: '',
      mobile: '',
      emailOptOut: '',
      birthday: '',
    },
    message: {
      termsAndConditions: '',
    },
    link: {
      privacy: '',
    },
  },
} as const;

const EMPTY_OBJECT = {};
// Outside defaultTranslations so that a new selector is not created on each get call
const getMergedTranslationsForLang = createSelector(
  () =>
    i18n.getResourceBundle('plugin', 'plugin-customerDisplay')
      ?.defaultTranslations ?? EMPTY_OBJECT,
  () =>
    i18n.getResourceBundle('dev', 'plugin-customerDisplay')
      ?.defaultTranslations ?? EMPTY_OBJECT,
  (lang: string, _: symbol) =>
    i18n.getResourceBundle(lang, 'plugin-customerDisplay')
      ?.defaultTranslations ?? EMPTY_OBJECT,
  (pluginTrans, devTrans, langTrans) =>
    R.reduce(R.mergeDeepRight, placeholderUntilLoaded, [
      // The order should be devTrans -> langTrans -> pluginTrans so that the "Custom Translations" plugin's texts apply - but since we're not sure if they should AND there's currently an issue where updates in Custom Translations plugin aren't reflected on CD, order is kept as is
      pluginTrans,
      devTrans,
      langTrans,
    ]),
);

/**
 * @deprecated
 * Acts like an object for compatibility, but really is powered by i18n now
 */
const defaultTranslations = new Proxy<
  Record<'en' | 'et' | string, typeof placeholderUntilLoaded>
>(
  {},
  {
    get(target, lang: string) {
      return getMergedTranslationsForLang(lang, Symbol('uniq'));
    },
  },
);

export default defaultTranslations;
